<div class="h-100 box d-flex flex-column px-2 pb-5">
    <div class="px-4">
        <div class="text-l font-semi-bold border-b border-dark py-5">{{ 'v3-byoc-popup-create-course-title' | translate }}</div>
    </div>

    <div class="flex-grow-1">
        <div #ps class="py-4 px-4 relative inner" [perfectScrollbar]="{ suppressScrollX: true, wheelPropagation: false }">
            <ng-container *ngIf="loaded">
                <!-- Name -->
                <div class="mb-4">
                    <label class="d-block text-s font-semi-bold" translate>v3-byoc-popup-create-course-general-name-label</label>
                    <input
                        (keydown.enter)="nextClick()"
                        class="w-100 info"
                        type="text"
                        maxlength="56"
                        [formControl]="controlTitle"
                        [ngClass]="{ 'danger-solid': controlTitle.invalid && controlTitle.dirty }"
                        [placeholder]="'v3-byoc-popup-create-course-general-name-placeholder' | translate"
                        formControlDataTest="name"
                    />
                    <div *ngIf="isNameTooLong" class="text-danger text-xs mt-2 font-semi-bold" translate>v3-title-character-limit-reached</div>
                </div>

                <!-- Level -->
                <div class="mb-4">
                    <div class="text-s font-semi-bold mb-4" translate>v3-byoc-popup-create-course-general-level-label</div>
                    <div>
                        <app-forms-dropdown-ac [control]="controlLevel" [placeholder]="placeholderLevels" [items]="levels"></app-forms-dropdown-ac>
                    </div>
                </div>

                <!-- Summary/Description/Content -->
                <div>
                    <label class="d-block text-s font-semi-bold" translate>v3-byoc-popup-create-course-general-summary-label</label>
                    <textarea
                        class="w-100 info"
                        [formControl]="controlContent"
                        [ngClass]="{ 'danger-solid': controlContent.invalid && controlContent.dirty }"
                        [placeholder]="'v3-byoc-popup-create-course-general-summary-placeholder' | translate"
                        formControlDataTest="courseDescription"
                    ></textarea>
                </div>
            </ng-container>

            <div *ngIf="!loaded" class="py-6">
                <app-loader loaderType="cover" overlayColor="white"></app-loader>
            </div>
        </div>
    </div>

    <div class="theme-new d-flex align-items-center px-4 pt-4">
        <button (click)="cancelClick()" class="btn btn-primary ms-auto" buttonDataTest="cancelButton" translate>v3-button-cancel</button>
        <button
            [ariaDisabled]="invalid"
            *ngIf="!isSubmodalOfAddingMission && !skipPosition"
            (click)="nextClick()"
            class="btn btn-secondary"
            [ngClass]="[invalid ? 'btn-disabled' : 'btn-secondary']"
            buttonDataTest="continueButton"
            translate
        >
            v3-button-continue
        </button>
        <button
            *ngIf="isSubmodalOfAddingMission"
            (click)="saveClick()"
            class="btn btn-primary"
            [ngClass]="[invalid || !loaded ? 'btn-disabled' : 'btn-secondary']"
            buttonDataTest="saveButton"
            translate
        >
            v3-button-save
        </button>
        <ng-container *ngIf="skipPosition">
            <button
                [disabled]="invalid || !loaded"
                (click)="saveAndAddClick()"
                class="btn"
                [ngClass]="[!invalid && loaded ? 'btn-secondary' : 'btn-disabled']"
                buttonDataTest="saveAndAddButton"
                translate
            >
                v3-button-save-and-add-learning-item
            </button>
            <button
                [disabled]="invalid || !loaded"
                (click)="saveNoPositionClick()"
                class="btn"
                [ngClass]="[!invalid && loaded ? 'btn-secondary' : 'btn-disabled']"
                buttonDataTest="saveButton"
                translate
            >
                v3-button-save
            </button>
        </ng-container>
    </div>

    <app-loader *ngIf="saving" loaderType="cover" overlayColor="white"></app-loader>
</div>
